module.exports = __webpack_public_path__ + "static/media/mmm.8cf8cfe7.png";